import { format } from 'date-fns';
// import _get from 'lodash/get';
// import _set from 'lodash/set';
// import _forEach from 'lodash/forEach';

export const getVideoOverviewDurationTextBySeconds = duration => {
    if (!isNaN(duration)) {
        const d = new Date(duration * 1000);
        return format(d, 'mm:ss');
    }
};
